import {SAVE_AUTH, SAVE_SUPER_AUTH} from "../actions/authActions";

const defaultState = {
    //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjVmN2Y5MDRjLTE3MzMtNDQ5My1hYjg0LWZiYTcyYWJjNTFhMCIsIm5iZiI6MTYxOTU1OTM3NSwiZXhwIjoxNjUwNjYzMzc1LCJpYXQiOjE2MTk1NTkzNzV9.BbXb8bcFq82p8qkEBaanA_I_loSPl9lRh2nDLGGWulI"
}

const authReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SAVE_AUTH:
            return { ...action.Auth }
        case SAVE_SUPER_AUTH:
            return { ...action.SuperAuth }
    }

    return state;
}

export default authReducer;